(() => {
  if (window.__caratCafeFamilyCardBound) return;
  window.__caratCafeFamilyCardBound = true;

  const chipSelector = '[data-cc-family-card-link]';

  const previewUrlFor = (productUrl) => {
    const url = new URL(productUrl, window.location.origin);
    const current = new URL(window.location.href);
    const previewThemeId = current.searchParams.get('preview_theme_id');

    if (previewThemeId) {
      url.searchParams.set('preview_theme_id', previewThemeId);
    }

    return url.pathname + url.search;
  };

  const updatePrice = (card, price) => {
    const targets = card.querySelectorAll(
      '.price__regular .price-item--regular, .price__sale .price-item--sale'
    );

    targets.forEach((node) => {
      node.textContent = price;
    });
  };

  const updateProductLinks = (card, productUrl) => {
    const targetUrl = previewUrlFor(productUrl);

    card.querySelectorAll('a[href]').forEach((anchor) => {
      if (anchor.matches(chipSelector)) return;
      if (anchor.closest('[data-cc-family-card]')) return;
      anchor.href = targetUrl;
    });
  };

  const selectFamilyMember = (chip) => {
    const family = chip.closest('[data-cc-family-card]');
    const card = chip.closest('.card-wrapper');

    if (!family || !card) return;

    family.querySelectorAll(chipSelector).forEach((item) => {
      const active = item === chip;
      item.classList.toggle('is-active', active);

      if (active) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });

    const price = chip.dataset.productPrice;
    const productUrl = chip.dataset.productUrl;
    const available = chip.dataset.productAvailable === 'true';

    if (price) updatePrice(card, price);
    if (productUrl) updateProductLinks(card, productUrl);

    const status = family.querySelector('[data-cc-family-card-status]');
    if (status) status.textContent = available ? 'In stock' : 'Sold out';
  };

  document.addEventListener('click', (event) => {
    const chip = event.target.closest(chipSelector);
    if (!chip) return;

    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) return;

    event.preventDefault();
    selectFamilyMember(chip);
  }, true);
})();
